import { atom } from "recoil";

// 選択した申込情報
export const orderState = atom({
  key: "orderState",
  default: {
    status: 'order_init',
    cource_id: null,
    cource_code: null,
    requestcource: null,
    requestpref_code: '',
    requestcource_clinic_id: '',
    requestclinic_id: null,
    requestclinic: null,
    options: [],
    requestdt1: null,
    requestdt1_ampm: '0',
    requestdt2: null,
    requestdt2_ampm: '0',
    requestdt3: null,
    requestdt3_ampm: '0',
    requestnote: '',
    examdt: null,
    examdtime: '',
    item_id: null,
  },
});